import React from "react";
import ScrollView from "sub_components/Common/BloxScrollViewNew";
import styled from "styled-components";
const TourBodyStyle = styled.div`
  height: 140px;
  cursor: pointer;
  width: 100%;

  .tour-list {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .tour-wrapper {
    margin-top: 5px;
    height: 20px;
  }
  .ScrollbarsCustom-Track {
    right: -10px !important;
    top: 0px !important;
  }
  .ScrollbarsCustom-ThumbY {
    background-color: ${(props) => props.theme.support} !important;
    width: 6px !important;
  }
  .ScrollbarsCustom-TrackY:before {
    border-left: none;
  }
  .ScrollbarsCustom-TrackY {
    background-color: ${(props) => props.theme.Cool_Gray_Light_2} !important;
    box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
      1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
    width: 6px !important;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
    height: 200px;
    .tour-wrapper {
      margin-top: 5px;
      height: 25px;
    }
    .ScrollbarsCustom-Track {
      right: -10px !important;
    }
    .ScrollbarsCustom-ThumbY {
      background-color: ${(props) => props.theme.support} !important;
      width: 8px !important;
    }

    .ScrollbarsCustom-TrackY {
      background-color: ${(props) => props.theme.Cool_Gray_Light_2} !important;
      box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
        1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
      width: 8px !important;
    }
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
    height: 370px;
    .tour-wrapper {
      margin-top: 10px;
      height: 30px;
    }
    .ScrollbarsCustom-Track {
      right: -10px !important;
    }
    .ScrollbarsCustom-ThumbY {
      background-color: ${(props) => props.theme.support} !important;
      width: 10px !important;
    }

    .ScrollbarsCustom-TrackY {
      background-color: ${(props) => props.theme.Cool_Gray_Light_2} !important;
      box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
        1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
      width: 10px !important;
    }
  }
`;

export const TourBody = ({
  id,
  cypressId,
  startTour,
  hasBillingAccess,
  hasProfileAccess,
  hasStorageAccess,
  hasSupportAccess,
  hasUserManagementAccess,
}) => {
  const tours = [
    {
      name: "How do I create a support request ?",
      url: "/portal/support",
      tour: "issue-request",
    },
  ];
  if (hasUserManagementAccess) {
    tours.push({
      name: "How do I add a user without data center access ?",
      url: "/portal/account/account_management",
      tour: "add-user",
    });
    tours.push({
      name: "How do I add a user with data center access ?",
      url: "/portal/account/account_management",
      tour: "add-user-badge",
    });
  }
  if (hasProfileAccess) {
    tours.push({
      name: "Account Overview.",
      url: "/portal/account?tour=true",
      tour: null,
    });
  }
  if (hasBillingAccess) {
    tours.push({
      name: "Billing Overview.",
      url: "/portal/billing?tour=true",
      tour: null,
    });
  }
  if (hasSupportAccess) {
    tours.push({
      name: "Support Overview.",
      url: "/portal/support?tour=true",
      tour: null,
    });
  }
  if (hasStorageAccess) {
    tours.push({
      name: "Storage Overview.",
      url: "/portal/storage?tour=true",
      tour: null,
    });
  }

  return (
    <TourBodyStyle id={id} cypressId={cypressId}>
      <ScrollView>
        <div className="tour-list">
          {tours &&
            tours.map((tour, index) => (
              <>
                <div
                  className="tour-wrapper header10"
                  onClick={() =>
                    startTour(tour?.url, { state: { tour: tour?.tour } })
                  }
                  onMouseOver={(e) => {
                    e.currentTarget.classList.add("header11");
                    e.currentTarget.classList.remove("header10");
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.classList.add("header10");
                    e.currentTarget.classList.remove("header11");
                  }}
                >
                  {tour?.name}
                </div>
                {index === 2 && tours?.length === 6 && <br />}
              </>
            ))}
        </div>
      </ScrollView>
    </TourBodyStyle>
  );
};
